import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { Message, PhoneInput } from '@fasstech/middle-design-system';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';
import handleValidationIndicator from '@@viewCommonComponents/controlled/helpers/handleValidationIndicator.js';
import { isRequiredSelect } from '@@viewHelpers/validations';
import { isNotNilOrEmpty } from '@@serverHelpers/index.mjs';
import { propOr } from 'ramda';

const ControlledPhoneInput = ({
  rules = {},
  form,
  name,
  internationalCodeName = 'internationalCode',
  isMobile = true,
  phoneNumberName = 'number',
  options = [],
  label,
  indicativeLabel = 'Indicatif',
  containerClassName = '',
  messageClassName = '',
  isDisplayed = true,
  disabled = false,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  const methods = useFormContext();

  const phoneNumber = form.watch(`${name}.${phoneNumberName}`);
  const testId = propOr('', 'data-testid', extraProps);

  useEffect(() => {
    methods.setValue(`${name}.isMobile`, isMobile);
  }, []);

  const indicativeRules = isRequiredSelect(
    options,
    isNotNilOrEmpty(options) && isNotNilOrEmpty(phoneNumber)
  );
  const numberFieldName = `${name}.${phoneNumberName}`;
  const indicativeFieldName = `${name}.${internationalCodeName}`;

  const indicativeDisabled =
    disabled && isNotNilOrEmpty(form.watch(indicativeFieldName));

  const numberErrorMessage = getErrorMessage(
    form.formState.errors,
    numberFieldName
  );
  const indicativeErrorMessage = getErrorMessage(
    form.formState.errors,
    indicativeFieldName
  );

  return (
    <div className={`w-full md:w-[100%]! ${containerClassName}`}>
      <Controller
        name={indicativeFieldName}
        control={form.control}
        defaultValue=""
        rules={indicativeRules}
        render={({ field: indicativeField }) => (
          <Controller
            name={numberFieldName}
            control={form.control}
            rules={rules}
            render={({ field: numberField }) => (
              <PhoneInput
                label={label}
                indicativeLabel={indicativeLabel}
                options={options}
                indicative={indicativeField.value}
                number={numberField.value}
                onIndicativeChange={(event) =>
                  indicativeField.onChange(event.target.value)
                }
                onNumberChange={numberField.onChange}
                disabled={disabled}
                indicativeSelectProps={{ disabled: indicativeDisabled }}
                error={handleValidationIndicator(
                  numberField.value,
                  rules,
                  numberErrorMessage
                )}
                indicativeError={handleValidationIndicator(
                  indicativeField.value,
                  indicativeRules,
                  indicativeErrorMessage
                )}
                data-testid={testId}
              />
            )}
          />
        )}
      />
      <Message
        className={messageClassName}
        variant="error"
        label={numberErrorMessage || indicativeErrorMessage}
      />
    </div>
  );
};

export default ControlledPhoneInput;
